import { GridSettingsContext as IGridSettingsContext } from '@tassat/common-definitions';
import { createContext } from 'react';

const GridSettingsContext = createContext<IGridSettingsContext | null>(null);

export { GridSettingsContext };